import { STATE_INITIAL } from 'Store/commonActions';

import type { LineState } from './types';

const initialState: LineState = {
  lineTokenState: STATE_INITIAL,
  updatedPersistLineButtonState: false,
};

export default initialState;
